/**
 * Horizontal slider behaviour for [data-slider-track] rows (currently the
 * recently-viewed row on the product page).
 *
 * The scrollbar is hidden by design, so this adds click-drag to move the row on
 * desktop, plus a scroll position indicator. Vertical wheel is intentionally left
 * alone so it scrolls the page. Touch devices scroll natively.
 */
(function () {
  'use strict';

  function initTrack(track) {
    if (!track || track.dataset.sliderReady === 'true') return;
    track.dataset.sliderReady = 'true';

    var section = track.closest('.rslider') || track.parentNode;
    var thumb = section ? section.querySelector('[data-slider-thumb]') : null;

    var down = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;

    function updateThumb() {
      if (!thumb) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }
      var widthPct = Math.max((track.clientWidth / track.scrollWidth) * 100, 10);
      thumb.style.width = widthPct + '%';
      thumb.style.left = ((track.scrollLeft / max) * (100 - widthPct)) + '%';
    }

    track.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);

    track.addEventListener('pointerdown', function (evt) {
      if (evt.pointerType === 'touch') return;
      down = true;
      dragged = false;
      startX = evt.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (evt) {
      if (!down) return;
      var dx = evt.clientX - startX;
      if (Math.abs(dx) > 3) dragged = true;
      if (dragged) {
        track.scrollLeft = startScroll - dx;
        evt.preventDefault();
      }
    });

    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (name) {
      track.addEventListener(name, function () { down = false; });
    });

    /* A drag ends in a click — don't let it open the product underneath. */
    track.addEventListener('click', function (evt) {
      if (dragged) {
        evt.preventDefault();
        evt.stopPropagation();
        dragged = false;
      }
    }, true);

    /* Deliberately no wheel handler: converting vertical wheel into horizontal
       scroll traps the page when someone scrolls past this row. Horizontal
       wheel/trackpad gestures already scroll the track natively. */

    /* Cards are injected by the theme after this runs, so re-measure when the
       track's contents change. */
    if (window.MutationObserver) {
      new MutationObserver(updateThumb).observe(track, { childList: true });
    }

    updateThumb();
  }

  function init() {
    document.querySelectorAll('[data-slider-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sections can be re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', init);
})();
